/*
|--------------------------------------------------------------------------
| EaselParent
|--------------------------------------------------------------------------
|
| This mixin lets a Vue component act as a container for an Easel Vue
| component.
|
*/

import easeljs from '../../easeljs/easel.js';
import sortByDom from '../libs/sort-by-dom.js';
import Vue from 'vue';
import findIndex from 'lodash.findindex';

export default {
    provide: function provide() {
        return {
            easel: this,
        };
    },
    data: function data() {
        return {
            // not guaranteed to be in order
            children: [],
        };
    },
    updated: function updated() {
        var this$1 = this;

        // runs when the DOM changes
        Vue.nextTick(function () { return this$1.syncEaselChildren(); });
    },
    watch: {
        children: function children() {
            this.syncEaselChildren();
        },
    },
    methods: {
        syncEaselChildren: function syncEaselChildren() {
            var this$1 = this;

            if (this.component) {
                sortByDom(this.children).forEach(function (vueChild, i) {
                    var atPosition = this$1.component.numChildren >= i ? this$1.component.getChildAt(i) : null;
                    if (vueChild.component === atPosition) {
                        // already there
                        return;
                    }
                    this$1.component.addChildAt(vueChild.component, i);
                });
            }
        },
        addChild: function addChild(vueChild) {
            if (!this.hasChild(vueChild)) {
                this.children.push(vueChild);
            }
        },
        removeChild: function removeChild(vueChild) {
            var index = this.indexOfChild(vueChild);
            if (index < 0) {
                return false;
            }
            this.children.splice(index, 1);
            if (this.component) {
                this.component.removeChild(vueChild.component);
            }
            return true;
        },
        hasChild: function hasChild(vueChild) {
            return this.indexOfChild(vueChild) > -1;
        },
        indexOfChild: function indexOfChild(vueChild) {
            return findIndex(this.children, vueChild);
        },
    },
};



// WEBPACK FOOTER //
// ./src/mixins/EaselParent.js